// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3u9xI","select":"Header_select__2zUPd","clinic":"Header_clinic___jhg2"};